import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-how-it-works-page',
  templateUrl: './how-it-works-page.component.html',
  styleUrls: ['./how-it-works-page.component.scss']
})
export class HowItWorksPageComponent {

   constructor(
          private router: Router
      ) {}

  goToPlan() {
        this.router.navigate(["order-flow"]);
    }
}
